import React from 'react'

const MaterialTestingServicesSteel = () => {
  return (
    <section className="services-details pt-120 pb-120">
      <div className="container">
        <div className="row">
          <div className="col-lg-6">
            <div className="section-title" />
          </div>
          <div className="col-lg-6">
            <div className="section-title" />
          </div>
          {/*Start Services Details Content*/}
          <div className="col-xl-12 col-lg-12">
            <div className="services-details__content">
              <h3>Material Testing Services – Steel </h3>
              <p className="mb-30">
                Steel is a critical construction material used in buildings,
                bridges, industrial structures, and infrastructure projects. Its
                mechanical and chemical properties directly change the strength,
                durability, and safety of structures. Steel Material Testing
                must verify that steel products meet design specifications,
                quality standards, and regulatory requirements.
              </p>
              <p className="mb-30">
                The need for standardized steel testing arose due to failures
                caused by substandard steel, improper fabrication, and
                non-compliance with specifications. International standards were
                developed to ensure uniform testing methods, correct assessment
                of mechanical properties, and reliable verification of steel
                quality.
              </p>
              <p className="mb-30">
                Without proper steel material testing, projects risk structural
                failure, safety hazards, costly rework, and non-compliance with
                design codes.
              </p>
              <div className="content mt-40">
                <div className="text">
                  <h3 className="mb-4">Purpose and Engineering Importance</h3>
                  <p className="mb-30">
                    The primary purpose of steel material testing is to provide
                    exact, verifiable data on the mechanical, chemical, and
                    physical properties of steel. This enables project
                    stakeholders to:
                  </p>
                  <ul className="project-list">
                    <li className="d-flex align-items-center">
                      <i className="icon fa-classic fa-solid fa-check fa-fw" />{" "}
                      Verifying tensile strength, yield strength, and elongation
                    </li>

                    <li className="d-flex align-items-center">
                      <i className="icon fa-classic fa-solid fa-check fa-fw" />{" "}
                      Confirming chemical composition and alloying elements
                    </li>

                    <li className="d-flex align-items-center">
                      <i className="icon fa-classic fa-solid fa-check fa-fw" />{" "}
                      Ensuring conformity with design and fabrication standards
                    </li>

                    <li className="d-flex align-items-center">
                      <i className="icon fa-classic fa-solid fa-check fa-fw" />{" "}
                      Detecting defects or inconsistencies before installation
                    </li>

                    <li className="d-flex align-items-center">
                      <i className="icon fa-classic fa-solid fa-check fa-fw" />{" "}
                      Supporting regulatory and contractual compliance
                    </li>
                  </ul>
                  <p className="mb-30">
                    Proper steel testing ensures structural integrity, enhances
                    safety, and reduces long-term maintenance risks.
                  </p>
                </div>
              </div>
              <div className="service-nr-list">
                <h3 className="mb-5">Our Services </h3>
                <p className="mb-30">
                  Pak Arab Inspection LTD. CO Company provides comprehensive steel
                  material testing services for structural, industrial, and
                  infrastructure projects. Our qualified engineers and
                  technicians perform testing following international standards,
                  project specifications, and client requirements.
                </p>
                <p className="mb-30">
                  Our services cover raw steel, fabricated components, and
                  in-situ steel structures, ensuring high-quality and safe
                  construction materials.
                </p>
              </div>
              <div className="service-nr-list">
                <h3 className="">Scope </h3>
                <h4 className="">
                  Our Steel Material Testing services typically include:
                </h4>
                <div className="row">
                  <div className="col-lg-4">
                    <h5>Mechanical Testing</h5>
                    <ul className="outcome-list mb-5">
                      <li>
                        <i className="fal fa-check" /> Tensile Test (Yield
                        Strength, Ultimate Strength, Elongation).
                      </li>

                      <li>
                        <i className="fal fa-check" /> Bend Test.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Hardness Test (Brinell,
                        Rockwell, Vickers).
                      </li>

                      <li>
                        <i className="fal fa-check" /> Impact Test (Charpy /
                        Izod).
                      </li>

                      <li>
                        <i className="fal fa-check" /> Fatigue and Fracture
                        Toughness Testing.
                      </li>
                    </ul>
                  </div>
                  <div className="col-lg-4">
                    <h5>Chemical Analysis</h5>
                    <ul className="outcome-list mb-5">
                      <li>
                        <i className="fal fa-check" /> Spectrochemical Analysis
                        (Alloy Composition).
                      </li>

                      <li>
                        <i className="fal fa-check" /> Carbon, Sulfur, and Other
                        Impurity Content.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Microstructure
                        Verification.
                      </li>
                    </ul>
                  </div>
                  <div className="col-lg-4">
                    <h5>Non-Destructive Testing (as required)</h5>
                    <ul className="outcome-list mb-5">
                      <li>
                        <i className="fal fa-check" /> Ultrasonic Testing (UT).
                      </li>

                      <li>
                        <i className="fal fa-check" /> Magnetic Particle Testing
                        (MT).
                      </li>

                      <li>
                        <i className="fal fa-check" /> Radiographic Testing
                        (RT).
                      </li>

                      <li>
                        <i className="fal fa-check" /> Visual Inspection and
                        Dimensional Verification.
                      </li>
                    </ul>
                  </div>
                  <div className="col-lg-4">
                    <h5>dimensional verification Specialized Tests</h5>
                    <ul className="outcome-list mb-5">
                      <li>
                        <i className="fal fa-check" /> Corrosion Resistance
                        Tests.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Weld Quality Assessment.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Surface Finish and
                        Coating Evaluation.
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default MaterialTestingServicesSteel